export default __webpack_public_path__ + "static/media/gallery_00.35b0786c.jpg";